import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  Image,
  Row,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { IMAGES } from "../../../assets/images/images";
import Skeleton from "react-loading-skeleton";
import { Myreferrals } from "../../../utility/apiServices/userServices";
import { useTranslation } from "react-i18next";
const userData = [
  {
    id: 1,
    title: "April Curtis",
    img: IMAGES.UserImg11,
    email: "aprilcurtis@gmail.com",
    phone: "9874563210",
  },
  {
    id: 2,
    title: "Sophie zox",
    img: IMAGES.UserImg1,
    email: "sophiezox@gmail.com",
    phone: "9874563210",
  },
  {
    id: 3,
    title: "Michael Smith",
    img: IMAGES.UserImg2,
    email: "michaelsmith@gmail.com",
    phone: "9874563210",
  },
  {
    id: 4,
    title: "Rose Gardner",
    img: IMAGES.UserImg3,
    email: "rosegardner@gmail.com",
    phone: "9874563210",
  },
];

const AffiliateScreen = () => {
  const {t} = useTranslation()
  const [isLoading, setisLoading] = useState(true);
  const [page, setpage] = useState(1);
  const [referralData, setreferralData] = useState();
  const [referrals, setreferrals] = useState();
  const [isloadMoreData, setisloadMoreData] = useState(false);
  const [totalPage, settotalPage] = useState(0);
  const [copytext, setcopytext] = useState("Copy");

  const GetReferralData = async (pageNumber) => {
    setisLoading(true);
    const response = await Myreferrals({ page: pageNumber });
    if (response?.status) {
      if (pageNumber == 1) {
        setreferrals(response?.data?.referrals);
      } else {
        setreferrals([...referralData, ...response?.data?.referrals]);
      }
      setreferralData(response?.data);
      settotalPage(response?.totalPages);
    } else {
    }
    setisLoading(false);
  };

  useEffect(() => {
    GetReferralData(page);
  }, []);

  const loadMoreData = async () => {
    setisloadMoreData(true);
    await GetReferralData(page + 1);
    setpage(page + 1);
  };

  // const copyToClipboard = (textToCopy) => {
  //   navigator.clipboard.writeText(textToCopy).then(
  //     () => {
  //       setcopytext("Copied!");
  //       setTimeout(() => setcopytext("Copy"), 2000); 
  //     },
  //     () => {
  //       // setcopytext("Failed to copy!");
  //       // setTimeout(() => setcopytext(""), 2000); 
  //     }
  //   );
  // };

  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(
        () => {
          setcopytext(t("myref.copied"));
          setTimeout(() => setcopytext("Copy"), 2000);
        },
        () => {
          fallbackCopyToClipboard(textToCopy);
        }
      );
    } else {
      fallbackCopyToClipboard(textToCopy);
    }

  };
  
  const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed"; // Avoid scrolling to bottom
    textArea.style.left = "-9999px"; // Position offscreen
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      setcopytext(successful ? "Copied!" : "Failed to copy!");
      setTimeout(() => setcopytext("Copy"), 2000);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  };
  

  return (
    <React.Fragment>
      <section
        className="referBg"
        style={{ backgroundImage: `url(${IMAGES.ReferBg})` }}
      >
        <Container fluid>
          <Row>
            <Col>
              <div className="referBg_Body">
              <h1>{t("myref.refer_title")}</h1>
                <p>{t("myref.refer_desc")}</p>
                <h3>{t("myref.share_code")}</h3>
                <div className="couponInput">
                  <div>
                    <FormControl
                      type="text"
                      value={referralData?.referralCode}
                    ></FormControl>
                    <Button
                      onClick={() =>
                        copyToClipboard(referralData?.referralCode)
                      }
                    >
                   { t("myref.copy")}
                    </Button>
                  </div>
                  <Button
                    onClick={() =>
                      (window.location.href = `mailto:?subject=Subject&body=Hey Join Lenim with my referral code ${referralData?.referralCode} to get extra 10% off`)
                    }
                  >
                    {t("myref.share")}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="commonpad">
        <Container fluid>
          <Row>
            <div className="referFlex">
            <h2>{t("myref.my_referrals")}</h2>
              <div className="referShadow">
                <div className="iconBox">
                  <Icon icon="lucide:wallet" fontSize={26} color="#ffffff" />
                </div>
                <div>
                  <h3>
                    {isLoading ? (
                      <Skeleton height={20} />
                    ) : (
                      "$" + (referralData?.totalEarnings ?? 0)
                    )}
                  </h3>
                  <p className="mb-0">{t("myref.my_earnings")}</p>
                </div>
              </div>
            </div>
            {isLoading ? (
              userData?.map((listing) => (
                <Col key={listing.id} xl={3} md={6}>
                  <div className="userCard">
                    <div className="userImg">
                      <Skeleton className="img-fluid" height={"100%"} />
                    </div>
                    <div className="userCardShadow">
                      <h2>
                        <Skeleton height={20} />
                      </h2>
                      <div className="user_Flex">
                        <Icon icon="mage:email" fontSize={20} />

                        <Skeleton height={20} width={100} />
                      </div>
                      <div className="user_Flex">
                        <Icon icon="solar:phone-outline" fontSize={20} />

                        <Skeleton height={20} width={100} />
                      </div>
                    </div>
                  </div>
                </Col>
              ))
            ) : referrals?.length && !isLoading ? (
              referrals?.map((listing) => (
                <Col key={listing.id} xl={3} md={6}>
                  <div className="userCard">
                    <div className="userImg">
                      <Image
                        src={
                          listing?.User?.profile_url
                            ? listing?.User?.profile_url
                            : IMAGES.UserDisImage
                        }
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <div className="userCardShadow">
                      <h2>{listing?.User?.name}</h2>
                      <div className="user_Flex">
                        <Icon icon="mage:email" fontSize={20} />

                        {listing?.User?.email}
                      </div>
                      <div className="user_Flex">
                        <Icon icon="solar:phone-outline" fontSize={20} />

                        {listing?.User?.phone_number}
                      </div>
                    </div>
                  </div>
                </Col>
              ))
            ) : (
              <div className="text-center">{t("myref.no_referrals")}</div>
            )}
          </Row>

          <div className="d-flex align-items-center justify-content-center mt-4">
            {totalPage > page && (
              <Button
                onClick={() => {
                  loadMoreData();
                }}
                variant="primary"
                className="px-5"
              >
                {isloadMoreData ? (
                  <span className="spinner-light"></span>
                ) : (
                 t("viewMore")
                )}
              </Button>
            )}
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AffiliateScreen;